import { PaginateQuery, PaginateResult } from "resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadePaginateResponse } from "./typings/unidade";

function useUnidades(
  { page = 1, limit = 10, search = undefined }: PaginateQuery,
  tenantId?: string
) {
  return useQuery(
    [`/v1/unidades-${page}-${limit}-${search}-${tenantId}`],
    async () => {
      const headers: any = {};

      if (tenantId) {
        headers.tenant = tenantId;
      }

      const res = await axios.get<PaginateResult<UnidadePaginateResponse>>(
        `/v1/unidades`,
        {
          params: {
            page,
            limit,
            search,
          },
          headers,
        }
      );

      return res.data;
    }
  );
}

export default useUnidades;
